export function getTeam(state) {
  return state.team;
}

export function getVolunteers(state) {
  return state.volunteers;
}

export function getVolunteerById(state) {
  return id => {
    return state.volunteers[id - 1];
  };
}
